import useTranslation from 'next-translate/useTranslation';
import { UnitSelect } from '@components/shared/UnitSelect/UnitSelect';
import { CADENCE_UNIT_OPTIONS } from '@components/Agreements/utils/agreementsConstants';
import { EventSeriesCadenceUnit } from 'types/EventSeries';

interface CadenceUnitSelectProps {
  count?: number | null;
  dataTestId: string;
  disabled?: boolean;
  onChange: (value: EventSeriesCadenceUnit) => void;
  value: EventSeriesCadenceUnit;
}

export const CadenceUnitSelect = ({ count, dataTestId, disabled, onChange, value }: CadenceUnitSelectProps) => {
  const { t } = useTranslation('common');

  return (
    <UnitSelect
      dataTestId={dataTestId}
      disabled={disabled}
      onChange={onChange}
      options={CADENCE_UNIT_OPTIONS(t, count)}
      value={value}
    />
  );
};
